import { useRouter } from "next/router"
import useStore from "components/ui/Context"
import { getAccessToken } from "lib/Cookies"
import { useEffect, useRef, useState } from "react"
import LoginAlert from "components/ModalLogin/LoginAlert"
import { Modal } from "components/ui"
import Image from "next/legacy/image"
import Link from "next/link"

export default function App(props) {
  const router = useRouter()
  const { toggleModalLogin, userInfo, signKey } = useStore()
  const {
    status,
    id,
    type,
    is_live,
    is_protected,
    name,
    start_time,
    thumbnail,
    thumbnail_horizontal,
    descriptions,
    color
  } = props

  const setModalLive = useStore().setModalLive
  const isMonter = useRef(false)
  const [isModal, setIsModal] = useState(false)
  const [srcImage, setSrcImage] = useState(thumbnail_horizontal || thumbnail)
  const [gradientStyle, setGradientStyle] = useState({})

  function onClick(e) {
    if (is_protected && !getAccessToken()) {
      isMonter.current = true
      setIsModal(true)
      e.preventDefault()
      return false
    }

    if (status !== "live") {
      setModalLive({
        show: true,
        isVod: false,
        info: {
          title: name,
          start_time
        }
      })
      e.preventDefault()
      return false
    }
  }

  function onClose() {
    setIsModal(false)
  }

  function onNext() {
    toggleModalLogin()
    setIsModal(false)
  }

  useEffect(() => {
    if (color) {
      const rgbaColor1 = hexToRgba(color, 0)
      const rgbaColor2 = hexToRgba(color, 0.85)
      const rgbaColor3 = hexToRgba(color, 1)

      setGradientStyle({
        background: `linear-gradient(180deg, ${rgbaColor1} 0%, ${rgbaColor2} 73.44%, ${rgbaColor3} 91.67%)`
      })
    }
  }, [color])

  useEffect(() => {
    if (isMonter.current && userInfo?.fullname) {
      router.push(`/video?id=${id}&type=${type}`)
    }
  }, [userInfo])

  useEffect(() => {
    if (isMonter.current && signKey) {
      router.push(`/video?id=${id}&type=${type}`)
    }
  }, [signKey])

  if (status === "live" || !is_live) {
    return (
      <>
        <div onClick={onClick}>
          <Link href={`/video?id=${id}&type=${type}`}>
            <div
              className={`relative flex flex-col rounded-xl overflow-hidden border border-[#131313] hover:border-white`}
              style={{ backgroundColor: `${color}` }}
            >
              <div className="relative fix_img">
                <Image
                  src={srcImage}
                  width={1600}
                  height={900}
                  alt={name}
                  className="object-cover max-w-full"
                  onError={() => setSrcImage("/placeholder_video.svg")}
                />
                <div className="flex items-center gap-1.5 absolute top-3 right-3 bg-[#13131385] backdrop-blur-xl rounded-[32px] py-1 px-2.5">
                  <img src="/icons/iconRedDot.svg" />
                  <span className="text-[#FAFAF9] text-xs min-[1440px]:text-sm font-normal">Đang phát sóng</span>
                </div>
                <div className="absolute bottom-0 left-0 w-full h-2/5" style={gradientStyle}></div>
              </div>
              <div className="w-full pb-5">
                {/* bg thay theo api: color */}
                <div className="flex flex-col gap-2 px-3">
                  <span className="text-lg min-[1440px]:text-xl text-[#FAFAF9] font-semibold line-clamp-1">{name}</span>
                  <div className="flex gap-4 items-end justify-between">
                    <span className="text-secondary text-sm font-normal line-clamp-2 h-10">{descriptions}</span>
                    {/* descriptions */}
                    <div className="flex gap-1.5 items-center bg-white rounded-lg py-1.5 px-2 whitespace-nowrap">
                      <span className="text-xs text-primary font-medium">Xem ngay</span>
                      <img src="/icons/iconPlayBlue.svg" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <Modal
          isOpen={isModal}
          onCancel={() => {
            setIsModal(false)
          }}
          showIcon={false}
        >
          <LoginAlert
            onCancel={() => {
              setIsModal(false)
            }}
            onNext={onNext}
          />
        </Modal>
      </>
    )
  } else {
    return (
      <div onClick={onClick} className="cursor-pointer">
        <div
          className={`relative flex flex-col rounded-xl overflow-hidden border border-[#131313] hover:border-white`}
          style={{ backgroundColor: `${color}` }}
        >
          <div className="relative fix_img">
            <img
              src={srcImage}
              width={1600}
              height={900}
              alt={name}
              className="object-cover max-w-full"
              onError={() => setSrcImage("/placeholder_video.svg")}
            />
            <div className="flex items-center gap-1.5 absolute top-3 right-3 bg-[#13131385] backdrop-blur-xl rounded-[32px] py-1 px-2.5">
              <img src="/icons/iconRedDot.svg" alt="" />
              <span className="text-[#FAFAF9] text-xs min-[1440px]:text-sm font-normal">Sự kiện sắp diễn ra</span>
            </div>
            <div className="absolute bottom-0 left-0 w-full h-2/5" style={gradientStyle}></div>
          </div>
          <div className="w-full pb-5">
            <div className="flex flex-col gap-2 px-3">
              <span className="text-lg min-[1440px]:text-xl text-[#FAFAF9] font-semibold line-clamp-1">{name}</span>
              <span className="text-secondary text-sm font-normal line-clamp-2 h-10">{descriptions}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function hexToRgba(hex, alpha = 1) {
  hex = hex.replace(/^#/, "")

  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((x) => x + x)
      .join("")
  }

  if (hex.length !== 6) {
    console.log("Invalid HEX color.")
  }

  let r = parseInt(hex.substring(0, 2), 16)
  let g = parseInt(hex.substring(2, 4), 16)
  let b = parseInt(hex.substring(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
